import { html, css } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { AppComponent } from '../component';
import { SearchBar } from './searchBar';
import { ComponentId } from '@omegagrid/core';
import rp from '../global';

@customElement('rp-app-header')
export class Header extends AppComponent {

	static styles = [css`
		* {
			box-sizing: border-box;
		}

		:host {
			height: 100%;
			display: flex;
			flex-direction: row;
			
		}
	`];

	@property({type: String})
	text: string;

	@property({type: String})
	homeComponentId: ComponentId;

	@query('rp-app-search')
	searchBar: SearchBar;


	render = () => html`
		${this.homeComponentId ? html`
			<og-bucket-button 
				icon="house" 
				@click="${() => rp.host.openHome()}">
			</og-bucket-button>	
		` : html`<span style="width: 5px"></span>`}

		<div style="flex: 1">
			<rp-app-search .text="${this.text}"></rp-app-search>
		</div>
	`;
	
}
